/** GEL number fields use the Lari symbol and the currency's two decimals. */
export const GEL_CURRENCY_FORMAT: Intl.NumberFormatOptions = {
    currency: 'GEL',
    currencyDisplay: 'narrowSymbol',
    style: 'currency',
};
